// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8d2f9ba6","455":"46ff6f0c","977":"8ed41383"}[chunkId] + ".chunk.js";
};